import { useTranslation } from 'react-i18next';
const useChatTranslation = () => {
    const { t } = useTranslation();
    const translations = {
        actionPaymentCompleted: t('chat.actionPaymentCompleted'),
        actionPaymentError: t('chat.actionPaymentError'),
        actionPostbackError: t('chat.actionPostbackError'),
        clickToRetry: t('chat.clickToRetry'),
        clickToRetryForm: t('chat.clickToRetryForm'),
        connectNotificationText: t('chat.connectNotificationText'),
        connectNotificationSingleText: '{user}' + t('chat.connectNotificationSingleText'),
        conversationListHeaderText: t('chat.conversationListHeaderText'),
        conversationListRelativeTimeJustNow: t('chat.conversationListRelativeTimeJustNow'),
        conversationListRelativeTimeMinute: t('chat.conversationListRelativeTimeMinute'),
        conversationListRelativeTimeMinutes: '{value}' + t('chat.conversationListRelativeTimeMinutes'),
        conversationListRelativeTimeHour: t('chat.conversationListRelativeTimeHour'),
        conversationListRelativeTimeHours: '{value}' + t('chat.conversationListRelativeTimeHours'),
        conversationListRelativeTimeYesterday: t('chat.conversationListRelativeTimeYesterday'),
        conversationListTimestampFormat: t('chat.conversationListTimestampFormat'),
        conversationListPreviewAnonymousText: t('chat.conversationListPreviewAnonymousText'),
        conversationListPreviewCarouselText: t('chat.conversationListPreviewCarouselText'),
        conversationListPreviewFileText: '{user}' + t('chat.conversationListPreviewFileText'),
        conversationListPreviewFormText: '{user}' + t('chat.conversationListPreviewFormText'),
        conversationListPreviewFormResponseText: '{user}' + t('chat.conversationListPreviewFormResponseText'),
        conversationListPreviewImageText: '{user}' + t('chat.conversationListPreviewImageText'),
        conversationListPreviewLocationRequestText: '{user}' + t('chat.conversationListPreviewLocationRequestText'),
        conversationListPreviewUserText: t('chat.conversationListPreviewUserText'),
        conversationTimestampHeaderFormat: t('chat.conversationTimestampHeaderFormat'),
        couldNotConnect: t('chat.couldNotConnect'),
        couldNotConnectRetry: t('chat.couldNotConnectRetry'),
        couldNotConnectRetrySuccess: t('chat.couldNotConnectRetrySuccess'),
        couldNotLoadConversations: t('chat.couldNotLoadConversations'),
        emailChangeAddress: t('chat.emailChangeAddress'),
        emailDescription: t('chat.emailDescription'),
        emailFieldLabel: t('chat.emailFieldLabel'),
        emailFieldPlaceholder: t('chat.emailFieldPlaceholder'),
        emailFormButton: t('chat.emailFormButton'),
        emailLinkingErrorMessage: t('chat.emailLinkingErrorMessage'),
        fetchHistory: t('chat.fetchHistory'),
        fetchingHistory: t('chat.fetchingHistory'),
        fileTooLargeError: t('chat.fileTooLargeError') + '({size})',
        fileTypeError: t('chat.fileTypeError'),
        formErrorInvalidEmail: t('chat.formErrorInvalidEmail'),
        formErrorNoLongerThan: t('chat.formErrorNoLongerThan'),
        formErrorNoShorterThan: t('chat.formErrorNoShorterThan'),
        formErrorUnknown: t('chat.formErrorUnknown'),
        formFieldSelectPlaceholderFallback: t('chat.formFieldSelectPlaceholderFallback'),
        frontendEmailChannelDescription: t('chat.frontendEmailChannelDescription'),
        headerText: t('chat.headerText'),
        imageClickToReload: t('chat.imageClickToReload'),
        imageClickToView: t('chat.imageClickToView'),
        imagePreviewNotAvailable: t('chat.imagePreviewNotAvailable'),
        inputPlaceholder: t('chat.inputPlaceholder'),
        inputPlaceholderBlocked: t('chat.inputPlaceholderBlocked'),
        introAppText: t('chat.introAppText'),
        lineChannelDescription: t('chat.lineChannelDescription'),
        linkError: t('chat.linkError'),
        linkChannelPageHeader: t('chat.linkChannelPageHeader'),
        locationNotSupported: t('chat.locationNotSupported'),
        locationSecurityRestriction: t('chat.locationSecurityRestriction'),
        locationSendingFailed: t('chat.locationSendingFailed'),
        locationServicesDenied: t('chat.locationServicesDenied'),
        messageError: t('chat.messageError', { size: '{size}' }),
        messageIndicatorTitlePlural: '({count})' + t('chat.messageIndicatorTitlePlural'),
        messageIndicatorTitleSingular: '({count})' + t('chat.messageIndicatorTitleSingular'),
        messageRelativeTimeDay: '{value}' + t('chat.messageRelativeTimeDay'),
        messageRelativeTimeHour: '{value}' + t('chat.messageRelativeTimeHour'),
        messageRelativeTimeJustNow: t('chat.messageRelativeTimeJustNow'),
        messageRelativeTimeMinute: '{value}' + t('chat.messageRelativeTimeMinute'),
        messageTimestampFormat: t('chat.messageTimestampFormat'),
        messageDelivered: t('chat.messageDelivered'),
        messageSeen: t('chat.messageSeen'),
        messageSending: t('chat.messageSending'),
        messageTooLongError: t('chat.messageTooLongError') + '({size}).',
        messengerChannelDescription: t('chat.messengerChannelDescription'),
        newConversationButtonText: t('chat.newConversationButtonText'),
        notificationSettingsChannelsDescription: t('chat.notificationSettingsChannelsDescription'),
        notificationSettingsChannelsTitle: t('chat.notificationSettingsChannelsTitle'),
        notificationSettingsConnected: t('chat.notificationSettingsConnected'),
        notificationSettingsConnectedAs: t('chat.notificationSettingsConnectedAs'),
        prechatCaptureGreetingText: t('chat.prechatCaptureGreetingText'),
        prechatCaptureNameLabel: t('chat.prechatCaptureNameLabel'),
        prechatCaptureNamePlaceholder: t('chat.prechatCaptureNamePlaceholder'),
        prechatCaptureEmailLabel: t('chat.prechatCaptureEmailLabel'),
        prechatCaptureEmailPlaceholder: t('chat.prechatCaptureEmailPlaceholder'),
        prechatCaptureConfirmationText: t('chat.prechatCaptureConfirmationText'),
        prechatCaptureMailgunLinkingConfirmation: t('chat.prechatCaptureMailgunLinkingConfirmation'),
        sendButtonText: t('chat.sendButtonText'),
        settingsHeaderText: t('chat.settingsHeaderText'),
        shareLocation: t('chat.shareLocation'),
        smsBadRequestError: t('chat.smsBadRequestError'),
        smsCancel: t('chat.smsCancel'),
        smsChangeNumber: t('chat.smsChangeNumber'),
        smsChannelDescription: t('chat.smsChannelDescription'),
        smsChannelPendingDescription: t('chat.smsChannelPendingDescription'),
        smsContinue: t('chat.smsContinue'),
        smsInvalidNumberError: t('chat.smsInvalidNumberError'),
        smsLinkCancelled: t('chat.smsLinkCancelled'),
        smsLinkPending: t('chat.smsLinkPending'),
        smsPingChannelError: t('chat.smsPingChannelError'),
        smsSendText: t('chat.smsSendText'),
        smsStartTexting: t('chat.smsStartTexting'),
        smsTooManyRequestsError: t('chat.smsTooManyRequestsError'),
        smsTooManyRequestsOneMinuteError: t('chat.smsTooManyRequestsOneMinuteError'),
        smsUnhandledError: t('chat.smsUnhandledError'),
        syncConversation: t('chat.syncConversation'),
        tapToRetry: t('chat.tapToRetry'),
        tapToRetryForm: t('chat.tapToRetryForm'),
        telegramChannelDescription: t('chat.telegramChannelDescription'),
        unsupportedMessageType: t('chat.unsupportedMessageType'),
        unsupportedActionType: t('chat.unsupportedActionType'),
        uploadDocument: t('chat.uploadDocument'),
        uploadInvalidError: t('chat.uploadInvalidError'),
        uploadPhoto: t('chat.uploadPhoto'),
        uploadVirusError: t('chat.uploadVirusError'),
        viberChannelDescription: t('chat.viberChannelDescription'),
        viberChannelDescriptionMobile: t('chat.viberChannelDescriptionMobile'),
        viberQRCodeError: t('chat.viberQRCodeError'),
        wechatChannelDescription: t('chat.wechatChannelDescription'),
        wechatChannelDescriptionMobile: t('chat.wechatChannelDescriptionMobile'),
        wechatQRCodeError: t('chat.wechatQRCodeError'),
        whatsappChannelDescriptionDesktop: t('chat.whatsappChannelDescriptionDesktop'),
        whatsappChannelDescriptionMobile: t('chat.whatsappChannelDescriptionMobile'),
        whatsappLinkingError: t('chat.whatsappLinkingError'),
    };
    return translations;
};
export default useChatTranslation;
